import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { API, useApp } from "@/state/AppContext";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { token } = useApp();
  const [state, setState] = useState({ status: "polling", tries: 0 });
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { navigate("/pricing"); return; }
    let alive = true;
    let tries = 0;
    const poll = async () => {
      if (!alive) return;
      tries += 1;
      try {
        const r = await axios.get(`${API}/payments/status/${sid}`);
        if (r.data.payment_status === "paid") {
          setState({ status: "paid", tries });
          return;
        }
        if (r.data.status === "expired") {
          setState({ status: "expired", tries });
          return;
        }
      } catch (_) { void 0; }
      if (tries >= 20) { setState({ status: "timeout", tries }); return; }
      setState({ status: "polling", tries });
      setTimeout(poll, 2000);
    };
    poll();
    return () => { alive = false; };
  }, [sid, navigate, token]);

  return (
    <div className="px-6 pt-10 flex flex-col items-center text-center" data-testid="payment-success-page">
      {state.status === "polling" && (<>
        <Loader2 className="w-14 h-14 text-blue-600 animate-spin" />
        <h1 className="mt-6 text-2xl font-bold text-slate-900">Zahlung wird bestätigt …</h1>
        <p className="mt-2 text-slate-600">Bitte einen Moment Geduld.</p>
      </>)}
      {state.status === "paid" && (<>
        <CheckCircle2 className="w-16 h-16 text-emerald-500" />
        <h1 className="mt-6 text-2xl font-bold text-slate-900">Willkommen an Bord!</h1>
        <p className="mt-2 text-slate-600">Dein Plan ist aktiv. Viel Spaß mit BriefAssist.</p>
        <button data-testid="pay-success-home" onClick={() => navigate("/")}
          className="mt-6 px-6 py-3 rounded-2xl bg-blue-600 text-white font-semibold">Zur Startseite</button>
      </>)}
      {(state.status === "expired" || state.status === "timeout") && (<>
        <XCircle className="w-16 h-16 text-red-500" />
        <h1 className="mt-6 text-2xl font-bold text-slate-900">Zahlung nicht bestätigt</h1>
        <button data-testid="pay-retry" onClick={() => navigate("/pricing")}
          className="mt-6 px-6 py-3 rounded-2xl bg-blue-600 text-white font-semibold">Erneut versuchen</button>
      </>)}
    </div>
  );
}

export function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="px-6 pt-10 flex flex-col items-center text-center" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 text-slate-400" />
      <h1 className="mt-6 text-2xl font-bold text-slate-900">Zahlung abgebrochen</h1>
      <p className="mt-2 text-slate-600">Kein Problem — du kannst jederzeit upgraden.</p>
      <button onClick={() => navigate("/pricing")}
        className="mt-6 px-6 py-3 rounded-2xl bg-blue-600 text-white font-semibold" data-testid="cancel-back-pricing">
        Zurück zu den Plänen
      </button>
    </div>
  );
}
